export default "__VITE_ASSET__Do093JFe__"